module.exports = "/_next/static/images/9bd246ed63ca4e3468bdcfc7be0ce171-stapler@tablet768.jpg";